import { default as LoaderInline } from "./LoaderInline";

const Statistics = {
  LoaderInline,
};

export default Statistics;
